import React, {useContext} from "react";
import {ProductContext} from '../../../../pages/ProductStencil';
import { isEcommerceEnabled } from "../../../../../selectors/generic";

export const OverviewPromoText = () => {
    const {activeProductIndex, Packaging, SapDetails} = useContext(ProductContext);
    const PromoText = Packaging?.[activeProductIndex]?.Promotions?.[0]?.LongPromoText ?? null;

    if (!isEcommerceEnabled() || !PromoText || SapDetails?.[0]?.IsObsolete) {
        return null;
    }

    return (
        <p className="promo-text p-text-color-red">{PromoText}</p>
    );
};